import { defineStore } from 'pinia';

import IDeliveryZone from '@/models/deliveryZone';

import jsonApi from '@/libs/jsonapi';

type IDeliveryZoneState = {
  deliveryZones: IDeliveryZone[];
};

const useDeliveryZone = defineStore('deliveryZone', {
  state(): IDeliveryZoneState {
    return {
      deliveryZones: [],
    };
  },

  actions: {
    async fetchDeliveryZones(): Promise<void> {
      const { data } = await jsonApi.all('delivery-zones').get<IDeliveryZone[]>();
      this.deliveryZones = data;
    },
  },
});

export default useDeliveryZone;
